module.exports = __webpack_public_path__ + "static/media/chisiamo.d29534bd.png";